import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import OperateTag from '../BindRecoverServer/OperateTag';

// 灾备集群视角，展示主集群，且可以跳转查看
export default function MainServers({ disasterRecoveryClusters }) {
  const navigate = useNavigate();

  const navigateToMainCluster = (clusterName) => {
    navigate(`/cluster/dashboard?name=${clusterName}`);
  };

  return (
    <Root>
      {Object.entries(disasterRecoveryClusters).map(([clusterName]) => (
        <OperateTag
          key={clusterName}
          color='rgb(16, 184, 128)'
          onPopConfirm={() => navigateToMainCluster(clusterName)}
        >
          主集群：{clusterName}
        </OperateTag>
      ))}
    </Root>
  );
}

const Root = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  flex-wrap: wrap;
`;
